import script from "./AppLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLoader.vue?vue&type=script&setup=true&lang=ts"

import "./AppLoader.vue?vue&type=style&index=0&id=5cd47aa1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cd47aa1"]])

export default __exports__